import { Navigate, useLocation } from 'react-router-dom';

// Each portal now owns its own domain, so the old /admin and /c path prefixes
// are gone. This redirects any legacy prefixed URL to its flattened equivalent,
// preserving search + hash so in-flight Supabase invite/recovery emails (whose
// tokens ride in the query/hash) and old bookmarks keep working.
export function LegacyPrefixRedirect({ prefix }: { prefix: string }) {
  const location = useLocation();
  const path = location.pathname.slice(prefix.length) || '/';
  return (
    <Navigate to={{ pathname: path, search: location.search, hash: location.hash }} replace />
  );
}
